
import { Observable } from 'rxjs';

export abstract class EuDictService {

    constructor(private http: any) { }

    abstract getDictDataMaps(dictNames: string[]): Observable<any>

    abstract getDictDataValue(dictName: string, dictKey: string): Observable<any>

    abstract getDictDataObserable(dictName: string): Observable<any[]>

}